const anonymous = true // 登录鉴权元信息
const requiresAuth = true // 身份验证元信息
const keepAlive = true // keep-alive 缓存
const GX_Routes = {
  path: '/gx/:group',
  name: 'gxFrame',
  props: true,
  component: () => import('@components/Frame.vue'),
  meta: { anonymous, requiresAuth },
  children: [
    {
      /**
       * @description: 基础管理——角色管理
       */
      path: 'role',
      component: () => import('/src/views/gx/base/role/index.vue'),
      breadcrumbName: '角色管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 新增角色
       */
      path: 'role/add',
      component: () => import('/src/views/gx/base/role/addOrEdit.vue'),
      breadcrumbName: '新增角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 编辑角色
       */
      path: 'role/edit/:recordUid',
      component: () => import('/src/views/gx/base/role/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑角色',
      meta: { requiresAuth, funPath: '/base/role' }
    },
    {
      /**
       * @description: 基础管理——角色管理 -> 管理成员
       */
      path: 'role/members/:id',
      component: () => import('/src/views/gx/base/role/roleMember.vue'),
      props: true,
      breadcrumbName: '管理成员',
      meta: { requiresAuth, funPath: '/base/role', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——设备管理
       */
      path: 'device',
      component: () => import('/src/views/gx/base/device/index.vue'),
      breadcrumbName: '设备管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——场所管理
       */
      path: 'place',
      component: () => import('/src/views/gx/base/place/index.vue'),
      breadcrumbName: '场所管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——场所管理->管理设备
       */
      path: 'place/device/:id',
      component: () => import('/src/views/gx/base/place/device.vue'),
      props: true,
      breadcrumbName: '关联设备',
      meta: { requiresAuth, funPath: '/gx/base/place' }
    },
    // ---------------------------------------------------------------- //
    // {
    //   /**
    //    * @description: 基础管理——本机构信息
    //    */
    //   path: 'sportsGame/sportsMeet/sportsMeetList',
    //   component: () => import('/src/views/gx/sportsGame/sportsMeet/sportsMeetList.vue'),
    //   breadcrumbName: '运动会列表',
    //   meta: { requiresAuth }
    // },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——机构管理——学期学年
       */
      path: 'org/acayear',
      component: () => import('/src/views/gx/base/org/acayear/index.vue'),
      props: true,
      breadcrumbName: '学年学期',
      meta: { funPath: '/gx/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——学期学年——新增编辑
       */
      path: 'org/acayear/add',
      component: () => import('/src/views/gx/base/org/acayear/addOrEdit.vue'),
      props: true,
      breadcrumbName: '新增学年',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——学期学年——编辑
       */
      path: 'org/acayear/edit',
      component: () => import('/src/views/gx/base/org/acayear/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑学年',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——学级管理
       */
      path: 'org/grade',
      component: () => import('/src/views/gx/base/org/grade/index.vue'),
      props: true,
      breadcrumbName: '入学年份',
      meta: { requiresAuth, funPath: '/gx/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——班级管理
       */
      path: 'org/class',
      component: () => import('/src/views/gx/base/org/class/index.vue'),
      props: true,
      breadcrumbName: '班级管理',
      meta: { requiresAuth, funPath: '/gx/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——班级管理——新增编辑
       */
      path: 'org/class/add',
      component: () => import('/src/views/gx/base/org/class/addOrEdit.vue'),
      props: true,
      breadcrumbName: '班级管理',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——班级管理——新增编辑
       */
      path: 'org/class/edit/:classId',
      component: () => import('/src/views/gx/base/org/class/addOrEdit.vue'),
      props: true,
      breadcrumbName: '班级管理',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——院系管理
       */
      path: 'org/college',
      component: () => import('/src/views/gx/base/org/college/index.vue'),
      props: true,
      breadcrumbName: '院系管理',
      meta: { requiresAuth, funPath: '/gx/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——院系管理
       */
      path: 'org/college/addEdit',
      component: () => import('/src/views/gx/base/org/college/addOrEdit.vue'),
      props: true,
      breadcrumbName: '院系管理',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    {
      /**
       * @description: 基础管理——机构管理——专业管理
       */
      path: 'org/major',
      component: () => import('/src/views/gx/base/org/college/majorIndex.vue'),
      props: true,
      breadcrumbName: '专业管理',
      meta: { requiresAuth, funPath: '/gx/base/org', keepAlive }
    },
    {
      /**
       * @description: 基础管理——机构管理——专业管理
       */
      path: 'org/major/addEdit',
      component: () => import('/src/views/gx/base/org/college/majorAddOrEdit.vue'),
      props: true,
      breadcrumbName: '专业管理',
      meta: { requiresAuth, funPath: '/gx/base/org' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——本机构信息
       */
      path: 'currentOrg',
      component: () => import('/src/views/gx/base/currentOrg/index.vue'),
      breadcrumbName: '本机构信息',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 基础管理——本机构信息-> 编辑机构信息
       */
      path: 'currentOrg/edit/:orgId',
      component: () => import('/src/views/gx/base/currentOrg/edit.vue'),
      props: true,
      breadcrumbName: '编辑机构信息',
      meta: { requiresAuth, funPath: '/gx/base/currentOrg' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——组织测试——测试管理
       */
      path: 'organizeTest/testManage',
      component: () => import('/src/views/gx/sportTest/organizeTest/testManage/index.vue'),
      breadcrumbName: '测试管理',
      meta: { requiresAuth, funPath: '/gx/sportTest/organizeTest', keepAlive }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--新增计划
       */
      path: 'organizeTest/testManage/add',
      component: () => import('/src/views/gx/sportTest/organizeTest/testManage/addOrEdit.vue'),
      breadcrumbName: '新增计划',
      meta: { requiresAuth, funPath: '/gx/sportTest/organizeTest' }
    },
    {
      /**
       * @description: 体育测试——组织测试——测试管理--查看计划
       */
      path: 'organizeTest/testManage/check/:id',
      component: () => import('/src/views/gx/sportTest/organizeTest/testManage/checkPlan.vue'),
      props: true,
      breadcrumbName: '查看计划',
      meta: { requiresAuth, funPath: '/gx/sportTest/organizeTest' }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表
       */
      path: 'onlineManagement/competition',
      component: () => import('/src/views/gx/sportsGame/onlineManagement/competition'),
      breadcrumbName: '赛事列表',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 新增竞技排名赛
       */
      path: 'onlineManagement/competition/addRank',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionRank/addOrEdit.vue'
        ),
      breadcrumbName: '新增竞技排名赛',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 编辑竞技排名赛
       */
      path: 'onlineManagement/competition/editRank/:id',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionRank/addOrEdit.vue'
        ),
      props: true,
      breadcrumbName: '编辑竞技排名赛',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 竞技排名赛详情
       */
      path: 'onlineManagement/competition/detailRank/:id',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionRank/addOrEdit.vue'
        ),
      props: true,
      breadcrumbName: '竞技排名赛详情',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },

    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 新增闯关挑战赛
       */
      path: 'onlineManagement/competition/addChallenge',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionChallenge/addOrEdit.vue'
        ),
      breadcrumbName: '新增闯关挑战赛',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 编辑闯关挑战赛
       */
      path: 'onlineManagement/competition/editChallenge/:id',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionChallenge/addOrEdit.vue'
        ),
      props: true,
      breadcrumbName: '编辑闯关挑战赛',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },
    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 闯关挑战赛详情
       */
      path: 'onlineManagement/competition/detailChallenge/:id',
      component: () =>
        import(
          '/src/views/gx/sportsGame/onlineManagement/competition/competitionChallenge/addOrEdit.vue'
        ),
      props: true,
      breadcrumbName: '闯关挑战赛详情',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },

    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 闯关挑战赛数据
       */
      path: 'onlineManagement/competition/dataChallenge/:id',
      component: () =>
        import('/src/views/gx/sportsGame/onlineManagement/competitionData/dataChallenge'),
      props: true,
      breadcrumbName: '竞技排名赛数据',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },

    {
      /**
       * @description: 体育赛事——线上赛管理——赛事列表-> 竞技排名赛数据
       */
      path: 'onlineManagement/competition/dataRank/:id',
      component: () => import('/src/views/gx/sportsGame/onlineManagement/competitionData/dataRank'),
      props: true,
      breadcrumbName: '竞技排名赛数据',
      meta: { requiresAuth, funPath: '/gx/sportsGame/onlineManagement' }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育赛事——运动会管理——运动会列表
       */
      path: 'sportsMeet',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/sportsMeetList.vue'),
      breadcrumbName: '运动会管理',
      meta: { requiresAuth, keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——运动会列表
       */
      path: 'sportsMeet/add',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/sportsMeetListAdd.vue'),
      breadcrumbName: '新增运动会',
      meta: { requiresAuth, funPath: '/gx/sportsGame/sportsMeet', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——管理-详情
       */
      path: 'sportsMeet/detail',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/sportsMeetDetail.vue'),
      // props: true,
      breadcrumbName: '管理运动会',
      meta: { requiresAuth, funPath: '/gx/sportsGame/sportsMeet', keepAlive }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——编排
       */
      path: 'sportsMeet/detail/arrange',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/detailArrangeList.vue'),
      // props: true,
      breadcrumbName: '编排',
      meta: { requiresAuth, funPath: '/gx/sportsGame/sportsMeet' }
    },
    {
      /**
       * @description: 体育赛事——运动会日程表
       */
      path: 'sportsMeet/detail/calendar',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/calendar.vue'),
      // props: true,
      breadcrumbName: '日程表',
      meta: { requiresAuth, funPath: '/gx/sportsGame/sportsMeet' }
    },
    {
      /**
       * @description: 体育赛事——运动会管理——风采
       */
      path: 'sportsMeet/demeanor/:meetId',
      component: () => import('/src/views/gx/sportsGame/sportsMeet/sportsMeetListDemeanor.vue'),
      props: true,
      breadcrumbName: '运动风采',
      meta: { requiresAuth, funPath: '/gx/sportsGame/sportsMeet', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——组织测试——成绩查询
       */
      path: 'organizeTest/scoreSearch',
      component: () => import('/src/views/gx/sportTest/organizeTest/scoreSearch/index.vue'),
      breadcrumbName: '成绩查询',
      meta: { requiresAuth, funPath: '/gx/sportTest/organizeTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育测试——自主测试——测试记录
       */
      path: 'selfTest/testRecord',
      component: () => import('/src/views/gx/sportTest/selfTest/testRecord/index.vue'),
      breadcrumbName: '测试记录',
      meta: { requiresAuth, funPath: '/gx/sportTest/selfTest', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育锻炼——锻炼记录——自由锻炼
       */
      path: 'exerciseRecord/freeExercise',
      component: () => import('/src/views/gx/sportExercise/exerciseRecord/index.vue'),
      breadcrumbName: '自由锻炼',
      meta: { requiresAuth, funPath: '/gx/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录--趣味锻炼
       */
      path: 'exerciseRecord/funExercise',
      component: () => import('/src/views/gx/sportExercise/exerciseRecord/indexFun.vue'),
      breadcrumbName: '趣味锻炼',
      meta: { requiresAuth, funPath: '/gx/sportExercise/exerciseRecord', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——锻炼记录--竞技场
       */
      path: 'exerciseRecord/arena',
      component: () => import('/src/views/gx/sportExercise/exerciseRecord/indexArena.vue'),
      breadcrumbName: '竞技场',
      meta: { requiresAuth, funPath: '/gx/sportExercise/exerciseRecord', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 体育锻炼——统计报表——阳光跑班级报表
       */
      path: 'statisticsReport/sunshineRunClass',
      component: () =>
        import('/src/views/gx/statisticsReport/sunshineRunning/classReport/index.vue'),
      breadcrumbName: '阳光跑班级报表',
      meta: { requiresAuth, funPath: '/gx/sportExercise/statisticsReport', keepAlive }
    },
    {
      /**
       * @description: 体育锻炼——统计报表——阳光跑个人报表
       */
      path: 'statisticsReport/sunshineRunPerson',
      component: () =>
        import('/src/views/gx/statisticsReport/sunshineRunning/personReport/index.vue'),
      breadcrumbName: '阳光跑个人报表',
      meta: { requiresAuth, funPath: '/gx/sportExercise/statisticsReport', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 基础管理——用户管理——教职工管理
       */
      path: 'user/teacher',
      component: () => import('/src/views/gx/base/user/teacher'),
      breadcrumbName: '教职工',
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——新增用户
       */
      path: 'user/teacher/add',
      component: () => import('/src/views/gx/base/user/teacher/addOrEdit.vue'),
      breadcrumbName: '新增教职工',
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/teacher/edit/:id',
      component: () => import('/src/views/gx/base/user/teacher/addOrEdit.vue'),
      breadcrumbName: '编辑教职工',
      props: true,
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },

    {
      /**
       * @description: 基础管理——用户管理——学生管理
       */
      path: 'user/student',
      component: () => import('/src/views/gx/base/user/student'),
      breadcrumbName: '学生',
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——新增用户
       */
      path: 'user/student/add',
      component: () => import('/src/views/gx/base/user/student/addOrEdit.vue'),
      breadcrumbName: '新增学生',
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },
    {
      /**
       * @description: 基础管理——用户管理——编辑用户
       */
      path: 'user/student/edit/:id',
      component: () => import('/src/views/gx/base/user/student/addOrEdit.vue'),
      breadcrumbName: '编辑学生',
      props: true,
      meta: { requiresAuth, funPath: '/gx/base/user', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源
       */
      path: 'wikiManagement/schoolWiki',
      component: () => import('/src/views/gx/resources/wikiManagement/schoolWiki/index.vue'),
      breadcrumbName: '校本资源',
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源-新增资源
       */
      path: 'wikiManagement/schoolWiki/add',
      component: () =>
        import('/src/views/gx/resources/wikiManagement/schoolWiki/addOrEdit.vue'),
      breadcrumbName: '新增校本资源',
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-校本资源-编辑资源
       */
      path: 'wikiManagement/schoolWiki/edit/:id',
      component: () =>
        import('/src/views/gx/resources/wikiManagement/schoolWiki/addOrEdit.vue'),
      breadcrumbName: '编辑校本资源',
      props: true,
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类
       */
      path: 'wikiManagement/ResClassification',
      component: () => import('/src/views/gx/resources/wikiManagement/ResClassification/index.vue'),
      breadcrumbName: '资源分类',
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类-新增资源分类
       */
      path: 'wikiManagement/ResClassification/add',
      component: () =>
        import('/src/views/gx/resources/wikiManagement/ResClassification/addOrEdit.vue'),
      breadcrumbName: '新增资源分类',
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心-百科管理-资源分类-编辑资源分类
       */
      path: 'wikiManagement/ResClassification/edit/:id',
      component: () =>
        import('/src/views/gx/resources/wikiManagement/ResClassification/addOrEdit.vue'),
      breadcrumbName: '编辑资源分类',
      props: true,
      meta: { requiresAuth, funPath: '/gx/resources/wikiManagement', keepAlive }
    },

    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心——banner——banner
       */
      path: 'banner/bannerConfig',
      component: () => import('/src/views/gx/resources/banner/index.vue'),
      breadcrumbName: 'Banner配置',
      meta: { requiresAuth, funPath: '/gx/resources/banner', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 新增编辑
       */
      path: 'banner/bannerConfig/edit/:uid',
      component: () => import('/src/views/gx/resources/banner/editBanner.vue'),
      props: true,
      breadcrumbName: '编辑Banner配置',
      meta: { requiresAuth, funPath: '/gx/resources/banner' }
    },
    {
      /**
       * @description: 运营运维中心——banner—— -> 查看
       */
      path: 'banner/bannerConfig/detail/:uid',
      component: () => import('/src/views/gx/resources/banner/lookBanner.vue'),
      props: true,
      breadcrumbName: '查看Banner配置',
      meta: { requiresAuth, funPath: '/gx/resources/banner' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 主页发布管理
       */
      path: 'orgHomepage/homepagePublish',
      component: () => import('/src/views/gx/resources/orgHomepage/homepagePublish/index.vue'),
      breadcrumbName: '主页发布管理',
      meta: { requiresAuth, funPath: '/gx/resources/orgHomepage', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 新增主页发布
       */
      path: 'orgHomepage/homepagePublish/add',
      component: () => import('/src/views/gx/resources/orgHomepage/homepagePublish/addOrEdit.vue'),
      props: true,
      breadcrumbName: '新增主页',
      meta: { requiresAuth, funPath: '/gx/resources/orgHomepage' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 编辑主页发布
       */
      path: 'orgHomepage/homepagePublish/edit/:id',
      component: () => import('/src/views/gx/resources/orgHomepage/homepagePublish/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑主页',
      meta: { requiresAuth, funPath: '/gx/resources/orgHomepage' }
    },
    {
      /**
       * @description: 运营运维中心——机构主页管理 分类管理
       */
      path: 'orgHomepage/category',
      component: () => import('/src/views/gx/resources/orgHomepage/category/index.vue'),
      props: true,
      breadcrumbName: '分类管理',
      meta: { requiresAuth, funPath: '/gx/resources/orgHomepage', keepAlive }
    },
    // ---------------------------------------------------------------- //
    {
      /**
       * @description: 运营运维中心——宣传页管理——宣传页配置
       */
      path: 'promotionPage/promotionConfig',
      component: () => import('/src/views/gx/resources/promotionPage/promotionConfig/index.vue'),
      breadcrumbName: '宣传页配置',
      meta: { requiresAuth, funPath: '/gx/resources/promotionPage', keepAlive }
    },
    {
      /**
       * @description: 运营运维中心——宣传页管理——新增宣传页配置
       */
      path: 'promotionPage/promotionConfig/add',
      component: () => import('/src/views/gx/resources/promotionPage/promotionConfig/addOrEdit.vue'),
      breadcrumbName: '新增宣传页',
      meta: { requiresAuth, funPath: '/gx/resources/promotionPage' }
    },
    {
      /**
       * @description: 运营运维中心——宣传页管理——编辑宣传页配置
       */
      path: 'promotionPage/promotionConfig/edit/:id',
      component: () => import('/src/views/gx/resources/promotionPage/promotionConfig/addOrEdit.vue'),
      props: true,
      breadcrumbName: '编辑宣传页',
      meta: { requiresAuth, funPath: '/gx/resources/promotionPage' }
    },
    // ---------------------------------------------------------------- //

    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——测试结果
       */
      path: 'physiqueManage/testResult',
      component: () => import('/src/views/gx/hm/physiqueManage/testResult/index.vue'),
      breadcrumbName: '测试结果',
      meta: { requiresAuth, funPath: '/gx/hm/physiqueManage', keepAlive }
    },
    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——学生档案
       */
      path: 'physiqueManage/studentArchive',
      component: () => import('/src/views/gx/hm/physiqueManage/studentArchive/index.vue'),
      breadcrumbName: '学生档案',
      meta: { requiresAuth, funPath: '/gx/hm/physiqueManage', keepAlive }
    },
    {
      /**
       * @description: 国家学生体质健康测试——体质健康测试管理——测试结果->详情
       */
      path: 'physiqueManage/testResult/editUpReport',
      component: () => import('/src/views/gx/hm/physiqueManage/testResult/upReport.vue'),
      breadcrumbName: '详情',
      meta: { requiresAuth, funPath: '/gx/hm/physiqueManage' }
    }
  ]
}

export default GX_Routes
